<template>
  <b-row class="wrap-nav">
    <b-col
      v-for="(menu, i) in menus"
      :key="i"
      cols="12"
      md="auto"
      class="col"
    >
      <div
        :class="[menu.active ? 'active' : '']"
      >
        <div
          v-if="menu.name"
          @click.prevent="clickMenu(menu.id)"
        >
          <p>{{ menu.name }}</p>
        </div>

        <div v-if="!menu.name && false">
          <div
            @click.prevent="clickMenuDrop(menu.id)"
            class="title-dropdown"
            :class="[menu.active ? 'active' : '']"
          >
            Creativity Day
          </div>

          <div
            class="box-dropdown"
          >
            <ul :style="[
                { display: activeCreative ? 'block' : 'none' }
              ]">
              <li
                v-for="(menu, i) in menu.dropdown"
                :key="i"
                @click.prevent="clickMenu(menu.id)"
              >
                {{ menu.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    year: Number
  },

  data () {
    return {
      menus: [],
      // select: 'Creativity Day'
      select: '',
      activeCreative: false,
      yearId: 2019
    }
  },

  computed: {
    ...mapState({
      menuGalleries: state => state.gallery.menuGalleries
    })
  },

  methods: {
    matchMenu (data) {
      if (data) {
        data.forEach((item, i) => {
          if (item.id === 1 ||
              item.id === 2 || item.id === 3) {
            const obj = {
              id: item.id,
              name: item.name,
              dropdown: [],
              active: false
            }

            if (i === 0) {
              obj.active = true
            }

            this.menus.push(obj)
          } else {
            const obj = {
              id: 99,
              name: '',
              dropdown: [],
              active: false
            }

            const newObj = {
              id: item.id,
              name: item.name
            }

            if (!this.menus[2]) {
              this.menus[2] = obj
              this.menus[2].dropdown.push(newObj)
            } else {
              this.menus[2].dropdown.push(newObj)
            }
          }

          // if (item.name.toUpperCase() === 'TALKS'.toUpperCase() ||
          //     item.name.toUpperCase() === 'EHXIBITIONS'.toUpperCase() ||
          //     item.name.toUpperCase() === 'AWARDS PRESENTATION'.toUpperCase()) {
          //   let obj = {
          //     id: 99,
          //     name: '',
          //     dropdown: [],
          //     active: false
          //   }

          //   let newObj = {
          //     id: item.id,
          //     name: item.name
          //   }

          //   if (!this.menus[2]) {
          //     this.menus[2] = obj
          //     this.menus[2].dropdown.push(newObj)
          //   } else {
          //     this.menus[2].dropdown.push(newObj)
          //   }

          //   // this.menus.push(obj[2])

          //   // this.menusDrop.push(obj[2])
          // } else {
          //   let obj = {
          //     id: item.id,
          //     name: item.name,
          //     dropdown: [],
          //     active: false
          //   }

          //   if (i === 0) {
          //     obj.active = true
          //   }

          //   this.menus.push(obj)
          // }
        })
      }
    },

    clickMenu (index) {
      this.yearId = index

      const params = {
        id: index,
        year: this.year
      }

      this.$store.dispatch('gallery/getList', params)

      this.menus.forEach(menu => {
        menu.active = false

        if (menu.id === index) {
          menu.active = true
        }
      })

      if (index > 2) {
        this.menus[2].active = true
        this.activeCreative = false
      }
    },

    clickCreative (index) {
      this.menus.forEach(menu => {
        menu.active = false
        // eslint-disable-next-line
        if (menu.id == index) {
          menu.active = true
        }
      })
    },

    clickMenuDrop (index) {
      this.activeCreative = !this.activeCreative

      this.menus.forEach(menu => {
        menu.active = false

        if (menu.id === index) {
          menu.active = true
        }
      })
    }
  },

  created () {
    if (!this.detailGallery) {
      this.$store.dispatch('gallery/getMenus')
    } else {
      this.matchMenu(this.menuGalleries)
    }
  },

  watch: {
    menuGalleries (data) {
      this.matchMenu(data)
    },

    year (data) {
      // let filter = this.menus.filter(menu =>
      //   menu.active === true
      // )

      const params = {
        id: this.yearId,
        year: data
      }

      this.$store.dispatch('gallery/getList', params)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-nav {
  .col {
    div {
      margin: 12px 0;
      width: 100%;
      height: 62px;
      border-bottom: 1px solid #CCC;
      text-align: center;
      line-height: 1;
      font-size: 1.25rem;
      cursor: pointer;

      @media only screen and (min-width: $break-m) {
        width: 200px;
        border: none;
      }

      p {
        padding-top: 20px;
      }

      div {
        width: 100%;

        .title-dropdown {
          padding-top: 20px;
        }

        // .active- {
        //   border-bottom: 3px solid #ad0707;
        //   background-color: $active;
        //   color: white;
        // }

        .box-dropdown {
          position: relative;
          z-index: 10;
          border: none;

          ul {
            li {
              list-style-type: none;
              margin-top: 12px;
              padding: 14px 0;
              font-size: 1.25rem;
              color: $light;
              background-color: black;
            }
          }
        }
      }
    }

    .active {
      border-bottom: 3px solid #ad0707;
      background-color: $active;
      color: white;
    }
  }
}
</style>
